import { useHistory } from 'react-router'
import { usePrepareCart } from './usePrepareCart'

interface FinalizeOptions {
  redirectTo?: string
  shouldClearCart?: boolean
  alsoClearOrderState?: boolean
}

export function useFinalizeCheckout() {
  const history = useHistory()
  const { clearOrderData, setOrderId } = usePrepareCart() as any

  const finalize = async ({ redirectTo, shouldClearCart = true, alsoClearOrderState = true }: FinalizeOptions = {}) => {
    try {
      localStorage.removeItem('@CANNECT:ORDER_CHECKOUT_CART_ID')
    } catch (e) {
      console.error(e)
    }

    try {
      if (shouldClearCart || alsoClearOrderState) {
        setOrderId(null)
        clearOrderData()
      }
    } catch (e) {
      console.error(e)
    }

    if (redirectTo) {
      history.push(redirectTo)
    }
  }

  return { finalize }
}
